import React, { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import es from "./es.json";

// Segmentos que se omiten visualmente pero forman parte del path real
const HIDDEN_SEGMENTS = new Set([
  "Home",
  "DetailsDb",
  "Db",
  "dashboard",
  "administration",
  "Details",
  "Configuration",
  "Administration",
  "Contacts",
  "NewCampaign",
  "home",
  "Partner",
  "RCS",
  "rcs",
]);

const Breadcrumb = () => {
  const location = useLocation();

  const breadCrumbs = useMemo(() => {
    if (!location) return [];

    const segments = location.pathname.split("/").filter(Boolean);
    const crumbs = [];

    segments.forEach((segment, i) => {
      if (HIDDEN_SEGMENTS.has(segment)) return;
      const isDynamic =
        /^\d+$/.test(segment) || /^[a-f0-9-]{36}$/.test(segment);
      if (isDynamic) return;

      const decodedSegment = decodeURIComponent(segment);
      const label = es[decodedSegment] || decodedSegment;
      const href = "/" + segments.slice(0, i + 1).join("/");

      crumbs.push({ label, href });
    });

    return crumbs.map((crumb, i) => ({
      ...crumb,
      isLast: i === crumbs.length - 1,
    }));
  }, [location]);

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <div className="flex items-center">
        <div className="inline-flex items-center">
          <Link
            to="/"
            className="flex items-center h-8 text-base text-blue-400 rounded-md hover:text-slate-900 transition-colors duration-150"
          >
            Inicio
          </Link>
        </div>

        {breadCrumbs.map(({ label, href, isLast }, index) => (
          <div key={index} className="inline-flex items-center px-1">
            <span className="text-gray-600 text-sm select-none material-symbols-outlined">
              chevron_right
            </span>
            {isLast ? (
              <span
                aria-current="page"
                className="flex items-center font-medium text-slate-900 border-b-2 border-slate-900 cursor-default px-1 text-sm"
              >
                {label}
              </span>
            ) : (
              <Link
                to={href}
                className="flex items-center h-8 text-sm text-blue-400 rounded-md hover:text-slate-900 transition-colors duration-150"
              >
                {label}
              </Link>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;
